export const MAIN_COLOR = 'rgba(223, 204, 251, 1)';
export const MAIN_GRADIENT = ['rgb(224, 204, 251)', 'rgb(195, 194, 251)'];